export const joinUrl = (paths, query) => {
    const cleaned = paths.map((p) => String(p).replace(/^\/+|\/+$/g, ''));
    let url = cleaned.filter(Boolean).join('/') + '/';
    if (query && query.length > 0) {
        const queryString = query
            .filter(Boolean)
            .map((q) => String(q).replace(/^\?/, ''))
            .join('&');
        url += '?' + queryString;
    }
    return url;
};
